var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 35,
    viewBox: "0 0 28 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 26.1316C27.2343 27.8307 26.8688 28.5891 25.8828 30.0903C24.5091 32.1866 22.571 34.7977 20.1693 34.8198C18.0359 34.8398 17.4876 33.4286 14.5915 33.4456C11.6953 33.4626 11.0917 34.8449 8.95831 34.825C6.55664 34.8036 4.72167 32.4458 3.34655 30.348C-0.497313 24.485 -0.898943 17.6051 1.47178 13.9478C3.15642 11.3471 5.81528 9.82741 8.31423 9.82741C10.8589 9.82741 12.4588 11.2252 14.5634 11.2252C16.6048 11.2252 17.848 9.8252 20.7906 9.8252C23.0146 9.8252 25.3713 11.0384 27.0508 13.1348C21.5481 16.1556 22.4428 24.0264 28 26.1316Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2918 6.22218C20.4013 4.82179 21.2424 2.84606 20.9366 0.825195C19.1243 0.947034 17.0062 2.08118 15.769 3.55904C14.6457 4.90001 13.7182 6.88929 14.0791 8.82291C16.0558 8.88382 18.1028 7.72185 19.2918 6.22218Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.a0878805475ca698baed623ae19e5496.svg";
export { ForwardRef as ReactComponent };